// Fixed-tick loop (ENG-2): the sim advances in whole 20 TPS ticks; the render
// frame interpolates between the last two. Accumulator capped so a stalled tab
// can't spiral (E-1).
import { TICK } from '../sim/config';
import type { Game } from './boot';

const MS_PER_TICK = TICK.MS_PER_TICK; // 50
const MAX_FRAME_MS = MS_PER_TICK * TICK.MAX_CATCHUP_TICKS;

export function startLoop(game: Game): void {
  let last = performance.now();
  let acc = 0;
  let fpsWindow = 0;
  let fpsFrames = 0;

  const frame = (now: number): void => {
    requestAnimationFrame(frame);
    // Hangar §39.4 (M104.3): a minimized window keeps the RAF alive (so resuming is
    // instant) but does no tick or render work — `last` still advances so the
    // accumulator does not see one giant `rawDt` on the frame resume actually runs.
    if (game.renderPaused) {
      last = now;
      return;
    }
    const rawDt = now - last;
    const dt = Math.min(MAX_FRAME_MS, rawDt);
    last = now;
    acc += dt;
    while (acc >= MS_PER_TICK) {
      game.tick();
      acc -= MS_PER_TICK;
    }
    game.render(acc / MS_PER_TICK);

    // Track the worst real frame interval (uncapped) for the perf gate.
    if (rawDt > game.worstFrameMs) game.worstFrameMs = rawDt;
    fpsFrames++;
    fpsWindow += dt;
    if (fpsWindow >= 500) {
      game.fps = Math.round((fpsFrames * 1000) / fpsWindow);
      fpsFrames = 0;
      fpsWindow = 0;
    }
  };
  requestAnimationFrame(frame);
}
